import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './_helpers';

const accountModule = () => import('./account/account.module').then(x => x.AccountModule);
const patientModule = () => import('./patient/patient.module').then(x => x.PatientModule);
const doctorsModule = () => import('./doctors/doctors.module').then(x => x.DoctorsModule);
const browseItemsModule = () => import('./browse-items/browse-items.module').then(x => x.BrowseItemsModule);
const PortalAdminModule = () => import('./portaladmin/portaladmin.module').then(x => x.PortalAdminModule);

const routes: Routes = [
    { path: 'account', loadChildren: accountModule },
    { path: 'doctors', loadChildren: doctorsModule },
    { path: 'browse-items', loadChildren: browseItemsModule },
    { path: 'portal-admin', loadChildren: PortalAdminModule },
    { path: '', redirectTo:'/doctors',pathMatch: 'full'},
    { path: 'profile', loadChildren: patientModule, canActivate: [AuthGuard] },
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }